import { z } from 'zod';

export const ModelFormSchema = z.object({
  status: z.string().optional(),
  updatedAt: z.string().optional(),
  archiveUrl: z
    .union([z.string(), z.instanceof(File)])
    .optional(),
  typeId: z.string().min(1, 'Model type is required'),
  colorId: z.string().min(1, 'Model color is required'),
  genderId: z.string().min(1, 'Gender is required'),
  fileNameId: z.string().min(1, 'File name is required'),
  name: z
    .string()
    .min(3, 'Model name must be at least 3 characters long')
    .regex(/^[a-zA-Z0-9 ]+$/, {
      message: 'Only letters and numbers are allowed',
    })
    .max(100, 'Model name cannot exceed 100 characters'),
});

export type ModelFormValues = z.infer<typeof ModelFormSchema>;
